import Plush from './Plush'

export default Plush
